'use client'

import Link from 'next/link'
import { Download, ExternalLink } from 'lucide-react'
import SectionHeader from '@/components/ui/SectionHeader'
import MotionFadeIn from '@/components/ui/MotionFadeIn'

export interface DownloadItem {
  id: string
  type: 'download' | 'link'
  title: string
  description?: string
  href: string
}

export interface DownloadsClientProps {
  infoTagText?: string
  title?: string
  items: DownloadItem[]
}

export default function DownloadsClient({ infoTagText, title, items }: DownloadsClientProps) {
  return (
    <>
      <SectionHeader infoTagText={infoTagText || ''} title={title || 'Downloads'} />

      <div className="space-y-6 mt-8">
        {items.map((item, index) => {
          const Icon = item.type === 'link' ? ExternalLink : Download
          const actionLabel = item.type === 'link' ? 'Link öffnen' : 'Download'
          return (
            <MotionFadeIn key={item.id || index} delay={index * 0.05}>
              <Link
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex w-full items-center gap-6 bg-brand-surface-1 p-6 transition-colors hover:bg-brand-surface"
              >
                <div className="flex-1 min-w-0">
                  <p className="font-metropolis font-bold text-text-primary text-xl">{item.title}</p>
                </div>
                <div className="flex items-center gap-3 shrink-0 text-text-brand opacity-80 transition-opacity group-hover:opacity-100">
                  <span className="font-metropolis font-bold text-sm uppercase tracking-wide">
                    {actionLabel}
                  </span>
                  <Icon className="h-6 w-6" aria-hidden />
                </div>
              </Link>
            </MotionFadeIn>
          )
        })}
      </div>
    </>
  )
}
